var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shared-messages-callback-number-list',{attrs:{"callback-numbers":_vm.callbackNumbers,"show-nav-tab":true,"can-send-sms":true},on:{"loadCallbackList":_vm.loadCallbackNumbers}})
}
var staticRenderFns = []

export { render, staticRenderFns }